import React from "react";
import Header from "./header";
import Footer from "./footer";
import { App, Article, Section, Headline, Paragraph, Box } from "grommet";

const Resume = props => (
  <div>
    <Article full={true}>
      <Header page="resume" />
      <Box flex={true} size={{width: "xlarge"}} alignSelf="center">
        <iframe style={{flex:1, height:'100%', border: '0px none transparent'}} src="https://docs.google.com/document/d/e/2PACX-1vRGjg-c4BLsxqliLIUl0Jd9IaqjRxDIXq0Av8kVwfxWEGZ8ZKPlNjP-3qysvOIez9EByfEDP35djw3u/pub?embedded=true"></iframe>
      </Box>
      <Footer />
    </Article>
  </div>
);

export default Resume;



// WEBPACK FOOTER //
// ./src/components/resume.js